import { Breadcrumb, Button, Card, Checkbox, Col, message, Modal, Radio, Row, Select, Space, Spin, Tooltip, Typography } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useMemo, useReducer, useState } from 'react';
import Plot from 'react-plotly.js';
import { AreaChartOutlined, CheckOutlined, HomeOutlined } from '@ant-design/icons';

import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../Context';
import axios from 'axios';
import { CHILD_WELL_INFO, CHILD_WELL_INFO_ERROR, CHILD_WELL_INFO_SUCCESS, CROSS_WELL_BULK_UPDATE, CROSS_WELL_BULK_UPDATE_ERROR, CROSS_WELL_BULK_UPDATE_SUCCESS, CROSS_WELL_CORDINATES_DATA, CROSS_WELL_CORDINATES_DATA_ERROR, CROSS_WELL_CORDINATES_DATA_SUCCESS, DAS_SOCKET_DATA, DTS_SOCKET_DATA, PARENT_WELL_INFO, PARENT_WELL_INFO_ERROR, PARENT_WELL_INFO_SUCCESS } from './constants';
import crossWellReducer from './reducer';

const CrossWell = () => {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;

	const { state } = useLocation();
	const navigate = useNavigate();
	const initalState = {parentWellData : [], crossWellCrodinatesData:[], childWellData:[], loading: false, error: false };
	const [crossWellReducerData, dispatch] = useReducer(crossWellReducer, initalState);
	useAuth();
	const [openWellModal, setWellModal] = useState(false);
	const [visualizationType, setVisualizationType] = useState(state && state.visualisation ? state.visualisation : 'microseismicconfig');
	const [parentwellId, setParentWellId] = useState();
	const [dtsEnabled, setdtsEnabled] = useState();
	const [dasEnabled, setdasEnabled] = useState();
	const [viewType, setViewType] = useState( dasEnabled == false && dtsEnabled == true ? 'DTS' : dasEnabled == true && dtsEnabled == true ?  'DAS' : dasEnabled == true && dtsEnabled == false ? 'DAS': '' );
	const [dassocketurl, setDasSocketUrl] = useState(null);
	const [dtssocketurl, setDtsSocketUrl] = useState(null);
	const [dasSocket, setDasSocket] = useState();
	const [dtsSocket, setDtsSocket] = useState();
	const [spin, setSpin] = useState(false);
	const [camera, setCamera] = useState({
		eye: { x: 1, y: -2, z: 0.2 },
		center: { x: 0, y: -.2, z: -0.1 },
		up: { x: 0, y: 0, z: 1 },
	});

	let tempWellId;
	let dtsEnabled1 =true;
	let dasEnabled1 =true;
	let socketDTS = null;
	let socketDAS = null;
	let tempdasurl;
	let tempdtsurl;

	const visualizations = [{
		value : 'flowmonitoringconfig', label : 'Flow Monitoring'
	},{
		value : 'sandingressconfig', label : 'Sand Ingress'
	},{
		value : 'leakdetectionconfig', label : 'Leak Detection'
	},{
		value : 'fracturemonitoringconfig', label : 'Hydraulic Fracturing Analysis'
	},{
		value : 'microseismicconfig', label : 'Microseismic Monitoring'
	}];
	
	const welldata =[];

	crossWellReducerData && crossWellReducerData.parentWellData.map((item,index) => {

		if(item&&item[visualizationType] && item[visualizationType].crossWellEnabled){
			welldata.push({
				value : item.id,
				label : item.name.toUpperCase(),
				// startDepth : item.startDepth,
				// endDepth : item.endDepth,
				dasip: item && item[visualizationType] &&item[visualizationType].dasip,
				dasport : item && item[visualizationType] &&item[visualizationType].dasport,
				dtsip: item && item[visualizationType] &&item[visualizationType].dtsip,
				dtsport : item && item[visualizationType] &&item[visualizationType].dtsport,
				// dtsminth : item && item[visualizationType] && item[visualizationType].tempThresholdsOverride ?  item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.minThreshold : item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.defaultminThreshold ,
				// dtsmaxth : item && item[visualizationType] && item[visualizationType].tempThresholdsOverride ?  item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.maxThreshold : item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.defaultmaxThreshold,
				// dasminth : item && item[visualizationType] && item[visualizationType].ampThresholdsOverride ?  item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.minThreshold : item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.defaultminThreshold,
				// dasmaxth : item && item[visualizationType] && item[visualizationType].ampThresholdsOverride ?  item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.maxThreshold : item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.defaultmaxThreshold,
				// presminth :item && item[visualizationType] && item[visualizationType].pressThresholdsOverride ?  item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.minThreshold : item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.defaultminThreshold,
				// presmaxth : item && item[visualizationType] && item[visualizationType].pressThresholdsOverride ?  item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.maxThreshold : item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.defaultmaxThreshold,
				// pressip: item && item[visualizationType] &&item[visualizationType].pressureip,
				// pressport : item && item[visualizationType] &&item[visualizationType].pressureport,
				// pressEnabled : item.pressureEnabled,

				dasSocketurl : item && item[visualizationType] &&item[visualizationType].dasSocketurl,
				dtsSocketurl: item && item[visualizationType] &&item[visualizationType].dtsSocketurl,
				// pressSocketurl: item && item[visualizationType] &&item[visualizationType].pressSocketurl,
				dasSocketurlEnabled: item && item[visualizationType] &&item[visualizationType].dasSocketurlEnabled,
				dtsSocketurlEnabled: item && item[visualizationType] &&item[visualizationType].dtsSocketurlEnabled,
				// pressSocketurlEnabled: item && item[visualizationType] &&item[visualizationType].pressSocketurlEnabled,

				dtsEnabled : item.dtsEnabled,
				dasEnabled : item.dasEnabled
			});
			if (index === 0) {			
				tempWellId = item.id;
				dtsEnabled1 = item.dtsEnabled;
				dasEnabled1 = item.dasEnabled;
				tempdasurl = item && item[visualizationType] &&item[visualizationType].dasSocketurlEnabled ? `wss://${item && item[visualizationType] &&item[visualizationType].dasSocketurl}` : `ws://${item && item[visualizationType] &&item[visualizationType].dasip}:${item && item[visualizationType] &&item[visualizationType].dasport}`;
				tempdtsurl = item && item[visualizationType] &&item[visualizationType].dtsSocketurlEnabled ? `wss://${item && item[visualizationType] &&item[visualizationType].dtsSocketurl}` : `ws://${item && item[visualizationType] &&item[visualizationType].dtsip}:${item && item[visualizationType] &&item[visualizationType].dtsport}`;
				dtsEnabled1 = item.dtsEnabled;
				dasEnabled1 = item.dasEnabled;
				// tempstartDepth = item.startDepth;
				// tempendDepth = item.endDepth;
				// temppressurl = item && item[visualizationType] &&item[visualizationType].pressSocketurlEnabled ? `wss://${item && item[visualizationType] &&item[visualizationType].pressSocketurl}` : `ws://${item && item[visualizationType] &&item[visualizationType].pressureip}:${item && item[visualizationType] &&item[visualizationType].pressureport}`;				// tempdtsurl = `ws://${item && item[visualizationType] &&item[visualizationType].dtsip}:${item && item[visualizationType] &&item[visualizationType].dtsport}`;
				// tempdtsminth = item && item.tempThresholdsOverride ?  item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.minThreshold : item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.defaultminThreshold;
				// tempdtsmaxth = item && item.tempThresholdsOverride ?  item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.maxThreshold : item[visualizationType] && item[visualizationType].tempThresholds && item[visualizationType].tempThresholds.defaultmaxThreshold;
				// tempdasminth = item && item.ampThresholdsOverride ?  item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.minThreshold : item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.defaultminThreshold;
				// tempdasmaxth = item && item.ampThresholdsOverride ?  item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.maxThreshold : item[visualizationType] && item[visualizationType].ampThresholds && item[visualizationType].ampThresholds.defaultmaxThreshold;
				// temppresminth = item && item.pressThresholdsOverride ?  item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.minThreshold : item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.defaultminThreshold;
				// temppresmaxth = item && item.pressThresholdsOverride ?  item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.maxThreshold : item[visualizationType] && item[visualizationType].pressThresholds && item[visualizationType].pressThresholds.defaultmaxThreshold;
				// temppressurl = `ws://${item && item[visualizationType] &&item[visualizationType].pressureip}:${item && item[visualizationType] &&item[visualizationType].pressureport}`;
				// temppressurl = `ws://${item.pressureip}:${item.pressureport}`;
				// temppressEnabled = item.pressureEnabled;
				// tempdtsEnabled = item.dtsEnabled;
				// dasEnabled1 = item.dasEnabled;
			}

		}
	});


	const childwelldata = useMemo(() => {
		if (!crossWellReducerData?.childWellData) return [];
		return crossWellReducerData.childWellData
			.filter(item => item && item[visualizationType])
			.map(item => ({
				value: item.id,
				label: item.name.toUpperCase(),
				startDepth: item.startDepth,
				endDepth: item.endDepth,
				dasip: item[visualizationType]?.dasip,
				dasport: item[visualizationType]?.dasport,
				dtsip: item[visualizationType]?.dtsip,
				dtsport: item[visualizationType]?.dtsport,
				dtsminth: item[visualizationType]?.tempThresholdsOverride
					? item[visualizationType]?.tempThresholds?.minThreshold
					: item[visualizationType]?.tempThresholds?.defaultminThreshold,
				dtsmaxth: item[visualizationType]?.tempThresholdsOverride
					? item[visualizationType]?.tempThresholds?.maxThreshold
					: item[visualizationType]?.tempThresholds?.defaultmaxThreshold,
				dasminth: item[visualizationType]?.ampThresholdsOverride
					? item[visualizationType]?.ampThresholds?.minThreshold
					: item[visualizationType]?.ampThresholds?.defaultminThreshold,
				dasmaxth: item[visualizationType]?.ampThresholdsOverride
					? item[visualizationType]?.ampThresholds?.maxThreshold
					: item[visualizationType]?.ampThresholds?.defaultmaxThreshold,
				presminth: item[visualizationType]?.pressThresholdsOverride
					? item[visualizationType]?.pressThresholds?.minThreshold
					: item[visualizationType]?.pressThresholds?.defaultminThreshold,
				presmaxth: item[visualizationType]?.pressThresholdsOverride
					? item[visualizationType]?.pressThresholds?.maxThreshold
					: item[visualizationType]?.pressThresholds?.defaultmaxThreshold,
				pressip: item[visualizationType]?.pressureip,
				pressport: item[visualizationType]?.pressureport,
				pressEnabled: item.pressureEnabled,
				dasSocketurl: item[visualizationType]?.dasSocketurl,
				dtsSocketurl: item[visualizationType]?.dtsSocketurl,
				pressSocketurl: item[visualizationType]?.pressSocketurl,
				dasSocketurlEnabled: item[visualizationType]?.dasSocketurlEnabled,
				dtsSocketurlEnabled: item[visualizationType]?.dtsSocketurlEnabled,
				pressSocketurlEnabled: item[visualizationType]?.pressSocketurlEnabled,
				crossWellEnabled: item[visualizationType]?.crossWellEnabled,
				dtsEnabled: item.dtsEnabled,
				dasEnabled: item.dasEnabled
			}));
	}, [crossWellReducerData?.childWellData, visualizationType]);

	const enabledChildIds = childwelldata
		.filter(child => child.crossWellEnabled)
		.map(child => child.value);

	const [crosswellIds, setCrossWellIds] = useState(enabledChildIds);
	

	useEffect(() => {
		if (childwelldata.length > 0 && crosswellIds.length === 0) {
			const enabledChildIds = childwelldata
				.filter(child => child.crossWellEnabled)
				.map(child => child.value);
			setCrossWellIds(parentwellId || tempWellId ? enabledChildIds : []);
		}
	}, [childwelldata]);

	useEffect(() => {
		loadWellParentInfo();
	},[]);
	
	useEffect(() => {
		loadWellChildInfo(parentwellId ? parentwellId : tempWellId);
	},[parentwellId, tempWellId]);

	useEffect(() => {
		getCrossWellCoordinatesData();
	},[crosswellIds]);


	const loadWellParentInfo = () => {
		dispatch({ type : PARENT_WELL_INFO });
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/wellinfo?isProdWell=true&$sort[id]=1`,
			timeout: timeout,
			headers: { 
				Authorization:`Bearer ${authtoken}`
			}
		};
			
		axios.request(config)
			.then((response) => {
				if(response.status == 200) {
					dispatch({ type : PARENT_WELL_INFO_SUCCESS, payload : response.data });
				} 
				else {
					dispatch({ type : PARENT_WELL_INFO_ERROR });
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : PARENT_WELL_INFO_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};	

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const showModal = () => {
		setWellModal(true);        
	};  

	const closeModal = () => {
		setWellModal(false);        
	};

	const handleSetVisualization = (value) => {
		if(dasSocket){
			dasSocket.close();
		}
		if(dtsSocket) {
			dtsSocket.close();
		}
		dispatch({type: DAS_SOCKET_DATA, payload:[]});
		dispatch({type: DTS_SOCKET_DATA, payload:[]});
		setCrossWellIds([]);
		setVisualizationType(value);
	};

	const loadWellChildInfo = (parentId) =>{

		if(parentId){

			dispatch({ type : CHILD_WELL_INFO });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/wellinfo?parentWellId=${parentId}&isProdWell=false&$sort[id]=1`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
				
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {
						dispatch({ type : CHILD_WELL_INFO_SUCCESS, payload : response.data });
					} 
					else {
						dispatch({ type : CHILD_WELL_INFO_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : CHILD_WELL_INFO_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}


	};
	
	const handleSetParentWell = (e , options) =>{		

		
		if(dasSocket){
			dasSocket.close();
		}
		if(dtsSocket) {
			dtsSocket.close();
		}
		
		// tempWellId=e;
		setParentWellId(e);
		loadWellChildInfo(e);
		setdtsEnabled(options.dtsEnabled);
		setdasEnabled(options.dasEnabled);
		setCrossWellIds([]);

		if(options.dasSocketurlEnabled){
			setDasSocketUrl(`wss://${options.dasSocketurl}`);

		}else{

			setDasSocketUrl(`ws://${options.dasip}:${options.dasport}`);
		}

		if(options.dtsSocketurlEnabled){
			setDtsSocketUrl(`wss://${options.dtsSocketurl}`);

		}else{

			setDtsSocketUrl(`ws://${options.dtsip}:${options.dtsport}`);
		}


	};

	useEffect(() => {
		setdtsEnabled(dtsEnabled1);
		setdasEnabled(dasEnabled1);
	},[dtsEnabled1, dasEnabled1]);	

	useEffect(() => {
		if(dasSocket){
			dasSocket.close();
		}
		if(dtsSocket) {
			dtsSocket.close();
		}
		setdtsEnabled(dtsEnabled1);
		setdasEnabled(dasEnabled1);
		setViewType(dasEnabled1 == false && dtsEnabled1 == true ? 'DTS' : dasEnabled1 == true && dtsEnabled1 == true ?  'DAS' : dasEnabled1 == true && dtsEnabled1 == false ? 'DAS': '');
	},[dtsEnabled1, dasEnabled1]);


	const webSocketDataDAS = () =>{			
			
		// const socket1 = new WebSocket(dassocketurl ? dassocketurl : tempdasurl); // Replace with your WebSocket URL
		// socket1.close();
		try {
			if(socketDAS == null){
	
			
				socketDAS = new WebSocket(dassocketurl ? dassocketurl : tempdasurl); // Replace with your WebSocket URL
				// console.log('socket.readyState',socket.readyState,WebSocket.OPEN);
				
				// if(socket.readyState == WebSocket.OPEN){
				// 	console.log('inn');
				// 	socket.close();
				// }
			
				setDasSocket(socketDAS);
				setSpin(true);		
		
				socketDAS.onopen = () => {
					console.log('WebSocket connection opened');
					setSpin(true);
				};
		
				socketDAS.onmessage = (event) => {
					try {
						const newData = JSON.parse(event.data);
						dispatch({type: DAS_SOCKET_DATA, payload:newData});
					
						// setWebsocketDASData(newData);
						setSpin(false);
		
					} catch (error) {
	
						setSpin(false);
						console.error('Error parsing data:', error);
					}
				};
		
				socketDAS.onerror = (error) => {
					setSpin(false);
					console.error('WebSocket error:', error);
				};
		
				socketDAS.onclose = () => {
					// setTimeout(setSpin(false), 5000);	
					// setTimeout(()=> {
					// 	webSocketDataDAS();
					// }, 10000);	
					setSpin(false);
					dispatch({type: DAS_SOCKET_DATA, payload:[]});
					console.log('WebSocket connection closed');
				};		
		
				const handlePopState = () => {			
					socketDAS.close();
					dispatch({type: DAS_SOCKET_DATA, payload:[]});
				};
	
				const handleUrlChange = () => {
					if (socketDAS) {
						socketDAS.close();
						dispatch({type: DAS_SOCKET_DATA, payload:[]});
					}
				};
			
				window.addEventListener('popstate', handlePopState);
	
				const originalPushState = history.pushState;
				const originalReplaceState = history.replaceState;
	
				history.pushState = function (...args) {
					originalPushState.apply(this, args);
					handleUrlChange(); // Close socket on push
				};
	
				history.replaceState = function (...args) {
					originalReplaceState.apply(this, args);
					handleUrlChange(); // Close socket on replace
				};
			
				return () => {
					window.removeEventListener('popstate', handlePopState);
					socketDAS.close();
					dispatch({type: DAS_SOCKET_DATA, payload:[]});
					history.pushState = originalPushState; // Restore original pushState
					history.replaceState = originalReplaceState; // Restore original replaceState
				};
			} 
		} catch (error) {
			setSpin(false);
			console.error('WebSocket error:', error);
			message.config({
				duration : 5,
				maxCount : 1,
			});
			message.open({
				type: 'error',
				content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
			});
			navigate('/connection-error');
		}
	
	
	};

	const webSocketDataDTS =()=>{
		// const socket = new WebSocket('ws://192.168.1.41:7891'); // Replace with your WebSocket URL
		// const socket1 = new WebSocket(dtssocketurl ? dtssocketurl : tempdtsurl); // Replace with your WebSocket URL
		// socket1.close();
		try {
			if(socketDTS==null){
	
				socketDTS = new WebSocket(dtssocketurl ? dtssocketurl : tempdtsurl);
				// if(socket.readyState == WebSocket.OPEN){
				// 	console.log('inn');
				// 	socket.close();
				// }
				setDtsSocket(socketDTS);
				setSpin(true);		
	
				socketDTS.onopen = () => {
					console.log('WebSocket connection opened');
					setSpin(true);
				};
	
				socketDTS.onmessage = (event) => {
					try {
						const newData = JSON.parse(event.data);
						// console.log('new Data', newData);
						dispatch({type: DTS_SOCKET_DATA, payload:newData});
	
					
				
						// setWebsocketDTSData(newData);
						setSpin(false);
	
					} catch (error) {
	
						setSpin(false);
						console.error('Error parsing data:', error);
					}
				};
	
				socketDTS.onerror = (error) => {
					setSpin(false);
					console.error('WebSocket error:', error);
				};
	
				socketDTS.onclose = () => {
					// setTimeout(setSpin(false), 5000);
					// setTimeout(()=> {
					// 	webSocketDataDTS();
					// }, 10000);		
					setSpin(false);
					dispatch({type: DTS_SOCKET_DATA, payload:[]});
					console.log('WebSocket connection closed');
				};		
	
				const handlePopState = () => {			
					socketDTS.close();
					dispatch({type: DTS_SOCKET_DATA, payload:[]});
				};
	
				const handleUrlChange = () => {
					if (socketDTS) {
						socketDTS.close();
						dispatch({type: DTS_SOCKET_DATA, payload:[]});
					}
				};
			
				window.addEventListener('popstate', handlePopState);
	
				const originalPushState = history.pushState;
				const originalReplaceState = history.replaceState;
	
				history.pushState = function (...args) {
					originalPushState.apply(this, args);
					handleUrlChange(); // Close socket on push
				};
	
				history.replaceState = function (...args) {
					originalReplaceState.apply(this, args);
					handleUrlChange(); // Close socket on replace
				};
			
				return () => {
					window.removeEventListener('popstate', handlePopState);
					socketDTS.close();
					dispatch({type: DTS_SOCKET_DATA, payload:[]});
					history.pushState = originalPushState; // Restore original pushState
					history.replaceState = originalReplaceState; // Restore original replaceState
				};
	
			}
		} catch (error) {
			setSpin(false);
			console.error('WebSocket error:', error);
			message.config({
				duration : 5,
				maxCount : 1,
			});
			message.open({
				type: 'error',
				content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
			});
			navigate('/connection-error');
		}
	
	};



	useEffect(() => {
	
		if((dassocketurl || tempdasurl) && (dasEnabled == true || dasEnabled1 == true) && viewType == 'DAS'){				
	
			webSocketDataDAS();
		}
		
	}, [dassocketurl,tempdasurl, parentwellId, viewType, visualizationType]);
		
		
	useEffect(() => {
	
		if((dtssocketurl || tempdtsurl) && (dtsEnabled == true || dtsEnabled1 == true) && viewType == 'DTS'){				
	
			webSocketDataDTS();
		}
		
	}, [dtssocketurl,tempdtsurl, parentwellId, viewType, visualizationType]);


	const getCrossWellCoordinatesData = () =>{			
		
		let wellids =  [...crosswellIds, parentwellId ? parentwellId : tempWellId];


		if(wellids && wellids.length > 0){

			dispatch({ type : CROSS_WELL_CORDINATES_DATA });
			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${api}/crosswellcooridnatesdata?wellIds=${JSON.stringify(wellids)}`,
				timeout: timeout,
				headers: { 
					Authorization:`Bearer ${authtoken}`
				}
			};
				
			axios.request(config)
				.then((response) => {
					if(response.status == 200) {						
						dispatch({ type : CROSS_WELL_CORDINATES_DATA_SUCCESS, payload : response });
					} 
					else {
						dispatch({ type : CROSS_WELL_CORDINATES_DATA_ERROR });
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : CROSS_WELL_CORDINATES_DATA_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	};


	const getCrossWellEnableUpdate = (wellId, value) =>{
		
		if(wellId){

			let data=JSON.stringify({
				crossWellEnabled: value,
			});

			dispatch({ type : CROSS_WELL_BULK_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/${visualizationType}?wellinfoId=${wellId}`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					'Authorization': `Bearer ${authtoken}`
				},
				data : data
			};
	
			axios.request(config)
				.then((response) => {
					if (response.status === 200) {
						dispatch({ type : CROSS_WELL_BULK_UPDATE_SUCCESS});
						// Modal.success({ title: `${langdata && langdata.Successfullyupdated ? langdata.Successfullyupdated :'Successfully updated.'}` });
						// data = response.data;
						message.success({
							content:  `${langdata && langdata.Successfullyupdated ? langdata.Successfullyupdated :'Successfully updated.'}`,
						});
					}else {
						dispatch({ type : CROSS_WELL_BULK_UPDATE_ERROR});
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : CROSS_WELL_BULK_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
		}


	};

	const onChange = (checkedValues) => {
				
		const newValues = checkedValues.filter(val => !crosswellIds.includes(val));
		const newuncheckedValues = crosswellIds.filter(val => !checkedValues.includes(val));
		for (const id of newValues) {
			
			getCrossWellEnableUpdate(id, true);
		}		

		for (const id of newuncheckedValues) {
			
			getCrossWellEnableUpdate(id, false);
			
		}
		
		setCrossWellIds(checkedValues);

	};

	const apiPlotData = useMemo(() => {
		
		if(tempWellId || parentwellId){
			if (
				crossWellReducerData &&
        Array.isArray(crossWellReducerData.crossWellCrodinatesData)
			) {
				return crossWellReducerData.crossWellCrodinatesData.map(item => {
				
					const isParent = item.wellId == (parentwellId && parentwellId != undefined ? parentwellId : tempWellId);
					return {
						x: item.x,
						y: item.y,
						z: item.z,
						mode: 'lines+markers',
						type: 'scatter3d',
						line: { width: 30, color: isParent ? 'red' : 'orange' },
						marker: { size: 2, color: isParent ? 'blue' : 'black' },
						// showlegend: false,
						name: `<b>${langdata?.WellName ?? 'Well Name'}<b>: ${item.wellName}<br>${langdata?.WellType ?? 'Well Type'}: ${isParent ? (langdata?.Productionwell ?? 'Production well') : (langdata?.Monitoringwell ?? 'Monitoring well')}`,
						hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z} <br> ${langdata?.WellName ?? 'Well Name'} : ${item.wellName} <br> ${langdata?.WellType ?? 'Well Type'} : ${isParent ? 'Production well' : 'Monitoring well'} <extra></extra>`,
						hoverlabel: {
							bgcolor: isParent ? '#e35959' : '#e3be59', // custom hover bg for this trace
							font: { color: 'black' },
							bordercolor: 'gray'
						}
					};
				});
			}
		}
		return [];

	}, [crossWellReducerData?.crossWellCrodinatesData, parentwellId, tempWellId, langdata]);	


	const websocketTracesDAS = crossWellReducerData && Array.isArray(crossWellReducerData?.dasData?.anomaly_coordinates)
		? crossWellReducerData.dasData.anomaly_coordinates.map((item, idx) => ({
			x: item.x,
			y: item.y,
			z: item.z,
			mode: 'markers',
			type: 'scatter3d',
			marker: {
				size: 7,
				color: `${item && item.colorCode && item.colorCode ? item.colorCode : 'purple'}`,
				opacity: 0.7,
				symbol: 'circle',
			},
			showlegend: idx === 0,
			name: idx === 0 ? `<b>${langdata?.Type ?? 'Type'}<b> : ${item && item.type && item.type ? item.type : 'Seismic' }` : undefined,
			hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z} <br> ${langdata?.Type ?? 'Type'} : ${item && item.type && item.type ? item.type : 'Seismic'} <extra></extra>`,
		}))
		: [];


	const websocketTracesDTS = crossWellReducerData && Array.isArray(crossWellReducerData?.dtsData?.anomaly_coordinates)
		? crossWellReducerData.dtsData.anomaly_coordinates.map((item, idx) => ({
			x: item.x,
			y: item.y,
			z: item.z,
			mode: 'markers',
			type: 'scatter3d',
			marker: {
				size: 7,
				color: `${item && item.colorCode && item.colorCode ? item.colorCode : 'purple'}`,
				opacity: 0.7,
				symbol: 'circle',
			},
			showlegend: idx === 0,
			name: idx === 0 ? `<b>${langdata?.Type ?? 'Type'}<b> : ${item && item.type && item.type ? item.type : 'Seismic' }` : undefined,
			hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z} <br> ${langdata?.Type ?? 'Type'} : ${item && item.type && item.type ? item.type : 'Seismic'} <extra></extra>`,
		}))
		: [];
	
	const layout = useMemo(() => ( {
		title: {
			text: langdata && langdata.CrossWellMonitoring ? langdata.CrossWellMonitoring : 'Cross well monitoring',
			font: {
				size: 20,
				// family: 'Arial, sans-serif',
				// color: 'black',
				weight: 'bold'
			},
		},
		scene: {
			xaxis: {
				title: langdata && langdata.Distancem ? langdata.Distancem : 'Distance (m)',
				color: 'black',          // Axis title & tick label color
				gridcolor: 'lightgray',  // Grid line color
				zerolinecolor: 'gray',   // Zero line color
				showbackground: true,
				backgroundcolor: '#fff5e5', // X axis plane background
				range:[0,200]
			},
			yaxis: {
				title: langdata && langdata.Offset ? langdata.Offset : 'Offset',
				color: 'black',
				gridcolor: 'lightgray',
				zerolinecolor: 'gray',
				showbackground: true,
				backgroundcolor: '#fff5e5', // Y axis plane background
				range:[-500, 500]
			},
			zaxis: {
				title: langdata && langdata.Depth ? langdata.Depth : 'Depth',
				color: 'black',
				gridcolor: 'lightgray',
				zerolinecolor: 'gray',
				showbackground: true,
				backgroundcolor: '#fff5e5', // Z axis plane background
				autorange: 'reversed',
				range:[0,500]
			},
			camera: camera
		},

		// paper_bgcolor: '#f0f0f0', // Canvas background
		// plot_bgcolor: '#f0f0f0',
		margin: { l: 0, r: 0, b: 0, t: 50 },
		showlegend: true,
		legend: {
			x: 0.87,
			bgcolor: 'rgba(255, 255, 255, 0)',
		},	
	}), [langdata, visualizationType, crosswellIds, camera]);

	const generateWaveSurface = (xArr, yArr) => {
		return yArr.map(y =>
			xArr.map(x => {
				const mainLayers = 0.6 * Math.sin(y / 1.5);         // horizontal, tight reflectors
				const fineBanding = 0.2 * Math.sin(y / 0.6);        // subtle thin layering
				const dip = 0.15 * Math.sin((x + y) / 30);          // gentle structural dip/flexure
				const envelope = 0.1 * Math.sin(y / 6);             // slow wave trend
				const noise = 0.01 * (Math.random() - 0.5);         // random micro-variation

				const total = mainLayers + fineBanding + dip + envelope + noise;
				return 0.5 * Math.tanh(total);  // tanh keeps range tight (-0.5 to 0.5)
			})
		);
	};

	const generateSurfaceTopViewData = (xArr, yArr) => {
		return yArr.map(y =>
			xArr.map(x => {
				const mainLayers = 0.6 * Math.sin(y / 1.5);         // horizontal, tight reflectors
				const fineBanding = 0.2 * Math.sin(y / 0.6);        // subtle thin layering
				const dip = 0.15 * Math.sin((x + y) / 30);          // gentle structural dip/flexure
				const envelope = 0.1 * Math.sin(y / 6);             // slow wave trend
				const noise = 0.01 * (Math.random() - 0.5);         // random micro-variation

				const total = mainLayers + fineBanding + dip + envelope + noise;
				return 0.5 * Math.tanh(total);  // tanh keeps range tight (-0.5 to 0.5)
			})
		);
	};

	const earthCoreColors = 'RdBu';

	const wellHeight = 5000;
	const xGrid = useMemo(() => Array.from({length: 21}, (_, i) => i * 10), []); // 0 to 200, 21 points
	const yGrid = useMemo(() => Array.from({length: 21}, (_, i) => -500 + i * 50), []); // -500 to 500, 21 points
	const zGrid = useMemo(() => Array.from({length: 21}, (_, i) => i * (wellHeight/20)), []); // 0 to 500, 21 points
	
	// Z Plane at z = 500 (top)
	const zPlaneData = useMemo(() => {
		const zValue = wellHeight;
		const z = Array.from({length: yGrid.length}, () => Array(xGrid.length).fill(zValue));
		const surfaceColor = generateSurfaceTopViewData(xGrid, zGrid); 
		return [{
			type: 'surface',
			x: xGrid,
			y: yGrid,
			z: z,
			surfacecolor: surfaceColor,
			colorscale: earthCoreColors,
			opacity: 0.7,
			showscale: false,
			colorbar: {
				title: langdata?.Depth ?? 'Depth',
				thickness: 15,
				len: 0.5,
				y: 0.7
			},
			name: 'Z Plane',
			showlegend: false,
			// hoverinfo: 'skip',
			hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z}<extra></extra>`,
		}];
	}, [langdata, xGrid, yGrid, wellHeight]);

	// X Plane at x = 0 (left)
	const xPlaneData = useMemo(() => {
		const xValue = 0;
		const x = Array.from({length: yGrid.length}, () => Array(zGrid.length).fill(xValue));
		const y = Array.from({length: yGrid.length}, () => yGrid);
		const z = zGrid.map(zv => Array(yGrid.length).fill(zv));
		const surfaceColor = generateWaveSurface(xGrid, zGrid); 
		return [{
			type: 'surface',
			x: x,
			y: y,
			z: z,
			surfacecolor: surfaceColor,
			opacity: 0.85,
			showscale: false,
			name: 'X Plane',
			showlegend: false,
			colorscale: earthCoreColors,
			hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z}<extra></extra>`,
		}];
	}, [langdata, yGrid, zGrid]);

	// Y Plane at y = 500 (front)
	const yPlaneData = useMemo(() => {
		const yValue = 500;
		const y = Array.from({length: xGrid.length}, () => Array(zGrid.length).fill(yValue));
		const x = Array.from({length: xGrid.length}, () => xGrid);
		const z = zGrid.map(zv => Array(xGrid.length).fill(zv));
		const surfaceColor = generateWaveSurface(xGrid, zGrid);
		return [{
			type: 'surface',
			x: x,
			y: y,
			z: z,
			surfacecolor: surfaceColor,
			colorscale: earthCoreColors,
			opacity: 0.85,
			showscale: false,
			name: 'Y Plane',
			showlegend: false,
			hovertemplate: ` ${langdata?.Distancem ?? 'Distance (m)'} : %{x} <br> ${langdata?.Offset ?? 'Offset'} : %{y} <br> ${langdata?.Depth ?? 'Depth'} : %{z}<extra></extra>`,
		}];
	}, [langdata, xGrid, zGrid]);

	const handleRelayout = (event) => {
		if (event['scene.camera']) {
			setCamera(event['scene.camera']);
		}
	};
	
	return (

		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
		
				<Col span={8}>
					<Row>
						<Space>
							<AreaChartOutlined style={{fontSize:'30px'}}/>
							{/* </Col> */}
						</Space>
						<Space>&nbsp;&nbsp;</Space>
							
						{/* <Col style={{marginLeft:'4px'}} span={19}> */}
						<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.CrossWellMonitoring ? langdata.CrossWellMonitoring : 'Cross well monitoring'}</Title>
						<Space>&nbsp;&nbsp;</Space>
						{dasEnabled == true && dtsEnabled == true ?
							<Space>
								<Radio.Group style={{margin:'5px'}} value={viewType} onChange={(e) => setViewType(e.target.value)}>
									{/* <Radio.Button value="DAS">{langdata && langdata.DAS ? langdata.DAS : 'DAS'}</Radio.Button>
									<Radio.Button value="DTS">{langdata && langdata.DTS ? langdata.DTS : 'DTS'}</Radio.Button> */}
								</Radio.Group>
							</Space>
							: null }
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							<Tooltip placement="bottom" title={langdata && langdata.SelecttheVisualizationtype ? langdata.SelecttheVisualizationtype : 'Select the Visualization type'}>
								<Space>
									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelecttheVisualizationtype ? langdata.SelecttheVisualizationtype : 'Select the Visualization type'}
										optionFilterProp="children"
										value={visualizationType}
										options={visualizations}
										onSelect={(e)=>handleSetVisualization(e)}
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>	
							<Tooltip placement="bottom" title={langdata && langdata.FilterbyWell ? langdata.FilterbyWell : 'Filter by well'}>
								<Space>
									{/* <Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.Selectthewells ? langdata.Selectthewells : 'Select the wells'}
										optionFilterProp="children"
										// defaultValuevalue={wells && wells[0]?.value}
										value={wells && wells[0]?.value}
										options={wells}
										onSelect={(e, options)=>handleSetParentWell(e, options)}
									/> */}

									<Select
										style={{ width: '180px', margin:'5px'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectWell ? langdata.SelectWell : 'Select Well'}
										optionFilterProp="children"
										value={parentwellId ? parentwellId : tempWellId}
										options={welldata}
										onSelect={(e, options)=>handleSetParentWell(e, options)}
									/>
								</Space>
							</Tooltip>
							<Space>&nbsp;</Space>
							<Tooltip placement="bottom" title={parentwellId || tempWellId ? (langdata && langdata.Selectmonitoringwells ? langdata.Selectmonitoringwells : 'Select monitoring wells') :(langdata && langdata.Pleaseselecttheproductionwell ? langdata.Pleaseselecttheproductionwell : 'Please select the production well') }>
								<Space>
									<Button 
										style ={{margin:'5px'}}
										disabled={parentwellId || tempWellId ? false : true} 
										type='primary' 
										onClick={showModal}
										icon={<CheckOutlined />}
										size='small' 
									>
									</Button>

								</Space>
							</Tooltip>	
						</Col>
					</Row>
				</Col>
			</Row>
			<Row style={{
				margin: '10px',
				// marginTop : '5px',
				// paddingLeft: '10px',
				// paddingRight: '10px',
				// background: '#FFFFFF',
				alignItems:'center',
			}}  >
				<Col span={18}>
					<Breadcrumb
						items={[
							{
								href: '/dashboard',
								title: <HomeOutlined />,
							},
							{
								title: <a onClick={()=>{navigate('/well-visualization');}}>{langdata && langdata.WellVisualization ? langdata.WellVisualization:'Well Visualization'}</a>
							},
							{
								title: (state && state.path && state.path == 'crosswell' ? <a onClick={()=>{navigate('/crosswell');}}>{state && state.pathName}</a> : null)
							},
							{
								title: `${langdata && langdata.CrossWellMonitoring ? langdata.CrossWellMonitoring : 'Cross well monitoring'}`,
							},
						]}
						// style={{ marginBottom : '10px'}}
					/>
				</Col>
				<Col span={6} style={{ display : 'flex', justifyContent : 'flex-end'}}>
					{/* <Tooltip title={langdata && langdata.Graphlayout ? langdata.Graphlayout:'Graph layout'}>
						<Switch style={{backgroundColor: graphScroll == false ? '' : 'green'}} checkedChildren={langdata && langdata.Scroll ? langdata.Scroll:'Scroll'} unCheckedChildren={langdata && langdata.Fixed ? langdata.Fixed:'Fixed'} checked={graphScroll} onClick={handleSelectGraphScroll}/>
					</Tooltip> */}
				</Col>
			</Row>
			{viewType == 'DAS' ? 
				<Card style={{ minHeight: '500px', padding : '5px', marginLeft : '20px', marginRight : '20px'  }}>
					<Row style={{
					// margin: '10px',
					// marginBottom : '0px',
					// marginTop : '10px',
					// paddingLeft: '10px',
					// paddingRight: '10px',
					// backgroundColor: '#ffffff',
						alignItems:'center',
					}} >
						<Col span={24}>				
							<Col >
								<Spin spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`} >
									{/* <Plot
										data={[...apiPlotData, ...zPlaneData, ...xPlaneData, ...yPlaneData, ...websocketTracesDAS]}
										layout={layout}
										// style={{ width: '100%', height: '100%' }}
										style={{ width: '100%', height: '800px' }}
										config={{
											responsive: true,
											displayModeBar: true,
											displaylogo : false,
											modeBarButtonsToRemove: [],
			
										}}
									/> */}

									<Plot
										data={[...apiPlotData, ...zPlaneData, ...xPlaneData, ...yPlaneData, ...websocketTracesDAS]}
										layout={layout}
										style={{ width: '100%', height: '800px' }}
										config={{
											responsive: true,
											displayModeBar: true,
											displaylogo : false,
											modeBarButtonsToRemove: [],
										}}
										onRelayout={handleRelayout}
									/>
								</Spin>
							</Col>
							{/* </Spin> */}
						</Col>
					</Row>
				</Card> :
				viewType == 'DTS' ?
					<Card style={{ minHeight: '500px', padding : '5px', marginLeft : '20px', marginRight : '20px'  }}>
						<Row style={{
							// margin: '10px',
							// marginBottom : '0px',
							// marginTop : '10px',
							// paddingLeft: '10px',
							// paddingRight: '10px',
							// backgroundColor: '#ffffff',
							alignItems:'center',
						}} >
							<Col span={24}>				
								<Col >
									<Spin spinning={spin} tip={`${langdata && langdata.Loading ? langdata.Loading: 'Loading'}...`} >
										<Plot
											data={[...apiPlotData, ...zPlaneData, ...xPlaneData, ...yPlaneData, ...websocketTracesDTS]}
											layout={layout}
											// style={{ width: '100%', height: '100%' }}
											style={{ width: '100%', height: '800px' }}
											config={{
												responsive: true,
												displayModeBar: true,
												displaylogo : false,
												modeBarButtonsToRemove: [],
			
											}}
										/>
									</Spin>
								</Col>
								{/* </Spin> */}
							</Col>
						</Row>
					</Card> : null 

			}
			<Modal
				title={langdata && langdata.CrossWellMonitoring ? langdata.CrossWellMonitoring :'Cross Well Monitoring'}
				centered
				destroyOnClose={true}
				open={openWellModal}
				onOk={{closeModal}}
				onCancel={closeModal}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={closeModal}>
							{langdata && langdata.CLOSE ? langdata.CLOSE :'CLOSE'}
						</Button>
						{/* <Button key="submit" type="primary" onClick={saveWellData}>
							{langdata && langdata.SAVE ? langdata.SAVE :'SAVE'}
						</Button> */}
					</Space>
				]}
				width={540}
			>
				<Row gutter={16}>
					<Col span={6}>
						<Typography>
							{langdata && langdata.WellInfo ? langdata.WellInfo :'Well Info'}:
						</Typography>
					</Col>
					{/* <Col span={18} style={{alignItems:'flex-end', justifyContent:'flex-end', display:'flex'}}>
						<Typography style={{color:' #CC3300'}}>
							{langdata && langdata.Onlythelastselectedwelldatawillbevisibleingraph ? langdata.Onlythelastselectedwelldatawillbevisibleingraph :'Only the last selected well data will be visible in graph.'}
						</Typography>
					</Col> */}
				</Row>

				<>
					<Row gutter={16} style={{
						backgroundColor: '#d3d3d3',
						padding: '5px',
						marginTop: '10px'
					}}>

						{ childwelldata && childwelldata ?
							childwelldata && childwelldata.map((data)=>(
								<Checkbox.Group  key={data.value} options={childwelldata} 
									defaultValue={crosswellIds}
									onChange={onChange} />))
							:
							<Col span={24}>
								<Typography>{langdata && langdata.Nowellfound ? langdata.Nowellfound :'No well found.'}</Typography>
							</Col>}
					</Row>
					<br/>

				</>
          
  
			</Modal>
			<Spin fullscreen spinning={crossWellReducerData.loading} />
		</Content>
		
	);
};

export default CrossWell;
